import { render, staticRenderFns } from "./VisualizarDocumentosPrestacoesFinais.vue?vue&type=template&id=7f72b123"
import script from "./VisualizarDocumentosPrestacoesFinais.vue?vue&type=script&lang=js"
export * from "./VisualizarDocumentosPrestacoesFinais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports